import * as yup from 'yup';

import * as rules from './rules';
import { getDefaultFields } from './defaultFields';

const ruleDefinitions = Object.keys(rules).map((rule) => rules[rule]);
ruleDefinitions.forEach(({ schemaType, name, method }) => yup.addMethod(schemaType, name, method));

const defaultFields = getDefaultFields(yup);

const buildSchema = (callback) => {

	const fieldSchema = callback(yup, defaultFields);
	return yup.object().shape(fieldSchema);

};

export { yup, buildSchema };
